module.exports = __webpack_public_path__ + "img/idp.b3f94871.png";